import { useState } from 'react';
import { CardNames, PlayerCards, WSPlayer } from 'shared';
import { SetState } from '../../../../../interfaces/SetState';

export interface IUsePlayer {
  data: WSPlayer;
  ready: boolean;
  cards: PlayerCards;
  movedWith?: CardNames;
  setReady: SetState<boolean>;
  setCards: SetState<PlayerCards>;
  setMovedWith: SetState<CardNames | undefined>;
}

const usePlayer = (
  playerData: WSPlayer,
  playerReady: boolean,
  playerCards: PlayerCards,
  playerMovedWith?: CardNames | null
): IUsePlayer => {
  const [data] = useState<WSPlayer>(playerData);
  const [ready, setReady] = useState(playerReady);
  const [cards, setCards] = useState<PlayerCards>(playerCards);
  const [movedWith, setMovedWith] = useState<CardNames | undefined>(
    playerMovedWith ? playerMovedWith : undefined
  );

  return { data, ready, cards, movedWith, setReady, setCards, setMovedWith };
};

export default usePlayer;
